'use client';

import { useEffect, useRef, useState } from 'react';

type DeferredModules = {
  ContactForm: (typeof import('./CustomContactForm'))['default'];
};

export function DeferredContactForm() {
  const hostRef = useRef<HTMLDivElement>(null);
  const [isNearViewport, setIsNearViewport] = useState(false);
  const [modules, setModules] = useState<DeferredModules | null>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    if (!('IntersectionObserver' in window)) {
      setIsNearViewport(true);
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;

        setIsNearViewport(true);
        observer.disconnect();
      },
      { rootMargin: '800px 0px' },
    );

    observer.observe(host);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isNearViewport || modules) return;

    let isMounted = true;

    import('./CustomContactForm').then(contactFormModule => {
      if (!isMounted) return;

      setModules({
        ContactForm: contactFormModule.default,
      });
    });

    return () => {
      isMounted = false;
    };
  }, [isNearViewport, modules]);

  const ContactForm = modules?.ContactForm;

  return (
    <div
      ref={hostRef}
      className="min-h-[760px] w-full md:max-w-[500px]"
      aria-busy={isNearViewport && !modules}
    >
      {ContactForm ? <ContactForm /> : null}
    </div>
  );
}
